import * as types from '../constants';
import { STATUS } from '../constants';
import { resolve } from '../api';

export const initialBlogState = {
  availableBlogs: null,
  availableBlogsStatus: STATUS.IDLE,
  blog: null,
  blogStatus: STATUS.IDLE,
  amberReportCount: 0,
  amberReportCountStatus: STATUS.IDLE,
  amberReportFeeds: [],
  amberReportFeedsStatus: STATUS.IDLE,
  amberReportTags: [],
  amberReportTagsStatus: STATUS.IDLE,
  enrichedIOCFeedBlogs: [],
  enrichedIOCFeedBlogsStatus: STATUS.IDLE,
};

export default (state = initialBlogState, action) => {
  switch (action?.type) {
    case types.LOAD_AMBER_REPORTS:
      return {
        ...state,
        availableBlogsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_AMBER_REPORTS): {
      return {
        ...state,
        availableBlogs: action?.payload,
        availableBlogsStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_AMBER_REPORT:
      return {
        ...state,
        blogStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_AMBER_REPORT): {
      return {
        ...state,
        blog: action?.payload,
        blogStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_AMBER_REPORT_COUNT:
      return {
        ...state,
        amberReportCountStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_AMBER_REPORT_COUNT): {
      return {
        ...state,
        amberReportCount: action?.payload,
        amberReportCountStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_AMBER_REPORT_AUTHORS:
      return {
        ...state,
        amberReportAuthorsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_AMBER_REPORT_AUTHORS): {
      return {
        ...state,
        amberReportAuthors: action?.payload,
        amberReportAuthorsStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_AMBER_REPORT_FEEDS:
      return {
        ...state,
        amberReportFeedsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_AMBER_REPORT_FEEDS): {
      return {
        ...state,
        amberReportFeeds: action?.payload,
        amberReportFeedsStatus: STATUS.LOADED,
      };
    }

    case types.LOAD_AMBER_REPORT_TAGS:
      return {
        ...state,
        amberReportTagsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_AMBER_REPORT_TAGS): {
      return {
        ...state,
        amberReportTags: action?.payload,
        amberReportTagsStatus: STATUS.LOADED,
      };
    }

    case types.FILTER_AMBER_REPORTS:
      return {
        ...state,
        availableBlogsStatus: STATUS.LOADING,
      };
    case resolve(types.FILTER_AMBER_REPORTS): {
      return {
        ...state,
        availableBlogs: action?.payload,
        availableBlogsStatus: STATUS.LOADED,
      };
    }

    case types.CHECK_ENRICHMENT_FEED_HAS_BLOGS:
      return {
        ...state,
        enrichedIOCFeedBlogsStatus: STATUS.LOADING,
      };
    case resolve(types.CHECK_ENRICHMENT_FEED_HAS_BLOGS): {
      return {
        ...state,
        enrichedIOCFeedBlogs: action?.payload,
        enrichedIOCFeedBlogsStatus: STATUS.LOADED,
      };
    }
    case types.RESET_CHECK_ENRICHMENT_FEED_HAS_BLOGS_STATE:
      return {
        ...state,
        enrichedIOCFeedBlogs: [],
        enrichedIOCFeedBlogsStatus: STATUS.IDLE,
      };

    case types.SET_AMBER_REPORTS_AS_SEEN:
      return {
        ...state,
        availableBlogsStatus: STATUS.LOADING,
        amberReportCountStatus: STATUS.LOADING,
      };
    case resolve(types.SET_AMBER_REPORTS_AS_SEEN): {
      //changing isSeen boolean on all reports in redux store, so we avoid recalling loadAmberReports
      let availableBlogsRedux = state?.availableBlogs;
      const reports = action?.payload?.results.map((report) => {
        let rep = report;
        rep.isSeen = true;
        return rep;
      });
      availableBlogsRedux.results = reports;

      return {
        ...state,
        availableBlogs: availableBlogsRedux,
        availableBlogsStatus: STATUS.LOADED,
        amberReportCount: 0,
        amberReportCountStatus: STATUS.LOADED,
      };
    }

    case types.SET_AMBER_REPORT_UNSEEN:
      return {
        ...state,
        availableBlogsStatus: STATUS.LOADING,
        amberReportCountStatus: STATUS.LOADING,
      };
    case resolve(types.SET_AMBER_REPORT_UNSEEN): {
      //changing isSeen boolean on a specific report in redux store, so we avoid recalling loadAmberReports
      let availableBlogsRedux = state?.availableBlogs;
      const reports = action?.payload?.results.map((report) => {
        let rep = report;
        if (report.uuid === action?.uuid) {
          rep.isSeen = false;
        }
        return rep;
      });
      availableBlogsRedux.results = reports;

      return {
        ...state,
        availableBlogs: availableBlogsRedux,
        availableBlogsStatus: STATUS.LOADED,
        amberReportCount: {
          count:
            (state.amberReportCount.count ? state.amberReportCount.count : 0) +
            1,
        },
        amberReportCountStatus: STATUS.LOADED,
      };
    }

    case types.SET_AMBER_REPORT_SEEN:
      //changing isSeen boolean on a specific report in redux store, so we avoid recalling loadAmberReports
      let availableBlogsRedux = state?.availableBlogs;
      let updatedCount = 0;

      const reports = availableBlogsRedux?.results.map((report) => {
        let rep = report;
        if (report.uuid === action?.uuid) {
          rep.isSeen = true;
        }
        return rep;
      });
      availableBlogsRedux.results = reports;

      if (state.amberReportCount.count === 0 || !state.amberReportCount.count) {
        updatedCount = 0;
      } else {
        updatedCount = state.amberReportCount.count - 1;
      }

      return {
        ...state,
        availableBlogs: availableBlogsRedux,
        availableBlogsStatus: STATUS.LOADED,
        amberReportCount: {
          count: updatedCount,
        },
        amberReportCountStatus: STATUS.LOADED,
      };

    default:
      return state;
  }
};
